module.exports = __webpack_public_path__ + "static/img/brand-16.c4c3de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-16.png
// module id = sX8T
// module chunks = 1